import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";
import style from "./style";

@define("m-activity-upload")
class Upload extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <section class='${style.upload}'>
        <h3 class='${style.upload__title}'>Entrega da atividade</h3>
        <div class='${style.upload__container}' center column xs>
          <h4 class='${style.upload__h4}'>Arraste o arquivo da atividade aqui</h4>
          <span class='${style.upload__preference}'>Ou, se preferir...</span>
          <label class='${style.upload__label}'>
            Selecione o arquivo do seu computador 
            <input class='${style.upload__input}'
              id='file'
              type='file'
            />
          </label>
          <span class='${style.upload__limit}'>Máximo de 25MB, ..zip</span>
        </div>
      </section>
    `;
  }

  @connected
  async [trait.toggle]() {
    const { data } = await supabase.storage
      .from("activities")
      .list(this.dataset.activity, {
        search: this.dataset.user,
      });

    data.length && this.remove();
    return this;
  }

  @on.change("input")
  async [trait.onChange](event: Event) {
    const file = (event.target as HTMLInputElement).files[0];

    await supabase.storage
      .from("activities")
      .upload(`${this.dataset.activity}/${this.dataset.user}`, file, {
        contentType: file.type,
      });

    location.reload();
  }
}

export default Upload;
